module.exports = __webpack_public_path__ + "img/downloadWithArrow.6963020a.svg";